<div class="titleblock">
  <h3 class="title1level">Atti processo telematico</h3>
  <p>
    <a href="javascript:void(0)" (click)="changeSelectMode()">
      {{ selectMsg }} <span [class]="'glyphicon '+((isSelectMode) ? 'glyphicon-save' : 'glyphicon-check')"></span>
    </a>
  </p>
</div>
  <div class="container_dati_generali">

    <div class="row  min-margin">
      <div class="col-sm-3 col-xs-12">
        <button class="btn btn-primary" aria-label="Aggiorna Dati" (click)="updatePct()" >Aggiorna dati  <span class="glyphicon glyphicon-refresh"></span></button>
      </div>

      <div class="col-xs-12 col-sm-5 col-md-offset-4" style="padding-left: 5px;" *ngIf="model">
          <span class="pda-last-update-label">Data ultimo aggiornamento: </span>
          <span class="pda-last-update-value"> {{ model.dataUltimoAggiornamento | date: "dd/MM/YYYY HH:mm" }} </span>
      </div>
    </div>

    <div *ngIf="model && model.actList?.length > 0">
      <div>
        <div class="panel panel-default min-margin" *ngFor="let act of orderActs(model.actList); let i = index">
          <div class="panel-heading">
            <!-- <h4 class="panel-title" style="position: relative;"> -->
              <div class="row">
                <div class="col-sm-2">
                  <div *ngIf="isSelectMode" class="form-group col-sm-12 listcheckbox">
                    <div style="display: flex;">
                      <input [disabled]="!isActSelectable(act)" [checked]="isActSelected(act)" (click)="onClickActSelected(act)" class="pct-act-checkbox" type="checkbox" id="select-atto-lbl-{{act.dataAtto}}" >
                      <label for="select-atto-lbl-{{act.dataAtto}}">
                        <small class="sr-only">Seleziona atto</small>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-sm-3"><b>Atto</b>: {{ truncateText(act.tipoAttoDescription,25) }}</div>
                <div class="col-sm-3"><b>Mittente</b>: {{ !!act.nominativoMittente ? truncateText(act.nominativoMittente,25) : act.mittente }}</div>
                <div class="col-sm-3"><b>Data: </b>{{ act.dataAtto | date: 'dd/MM/YYYY HH:mm' }}</div>
                <div class="col-sm-1">
                  <a [ngClass]="accordionToggleClassHandler()" data-toggle="collapse" data-parent="#accordion" href="#{{act.idAttoPct}}">
                    <small class="sr-only">Apri o chiudi atto</small>
                  </a>
                </div>
              </div>
              
            <!-- </h4> -->
          </div>
          <div [id]="act.idAttoPct" [ngClass]="accordionBodyClassHandler()" style="height:auto!important;">
            <div class="panel-body" style="padding: 0">
              <table class="table-striped table act-import min-margin ">
                <caption class="sr-only">Tabella Atti</caption>
                <tr>
                  <th scope="col" class="column-dimension">Dimensione</th>
                  <th scope="col" class="column-filename">Nome file</th>
                  <th scope="col" class="column-info" *ngIf="isSelectMode"></th>
                  <th scope="col" class="column-view"></th>
                  <th scope="col" class="column-info" *ngIf="isSelectMode">Seleziona</th>
                </tr>
                <tr class="borded" *ngFor="let x of act.listDocumentiPct; let i = index ">
                  <td class="column-dimension">{{dimensionTranslator(x.dimensione)}}</td>
                  <td class="column-filename"><a href="javascript:void(0)" (click)="downloadDirettoDoc(x)">{{x.nome}}</a></td>
                  <td class="column-info" *ngIf="isSelectMode">
                    <span class="glyphicon glyphicon-flag" *ngIf="isDocAlreadyImported(x)" title="Documento già importato"></span>
                  </td>
                  <td class="column-view">
                    <a *ngIf="canViewFile(x)" aria-label="Mostra anteprima documento" href="javascript:void(0)" (click)="viewDoc(x)">
						          <span class="glyphicon glyphicon-eye-open"></span>
                    </a>
                    <span 
                        *ngIf="!canViewFile(x)" 
                        class="glyphicon glyphicon-eye-close"
                        [appTooltip]="'L’anteprima non è disponibile perché il file supera le dimensioni massime consentite'" 
                        [appTooltipEnabled]="checkMaxLimitExceeded(x)">
                    </span>
                  </td>
                  <td class="column-info" *ngIf="isSelectMode">
                   <div *ngIf="isSelectMode" class="form-group col-sm-12 listcheckbox">
                    <div style="display: flex;">
                      <input [disabled]="!isActSelectable(act)" [checked]="isDocSelected(x)" (click)="onClickDocSelected(act, x)" class="pct-act-checkbox" type="checkbox" id="select-doc-lbl-{{x.refId}}" >
                      <label for="select-doc-lbl-{{x.refId}}">
                        <small class="sr-only">Seleziona documento</small>
                      </label>
                    </div>
                  </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>


<app-pda-section-nodata *ngIf="!model || model.actList.length === 0" ></app-pda-section-nodata>
